import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrum from "../../../../common/BreadCrum/BreadCrum";
import CommonTable from "../../../../common/table/ComonTable";
import SearchBar from "../../../../common/formfields/SearchBar";
import CustomSelect from "../../../../common/formfields/CustomSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faUpload, faPlus, faCheckCircle, faClipboardList, faCar, faIdCard, faChartPie } from "@fortawesome/free-solid-svg-icons";
import PageHeadingSection from "../../../../common/pageheading/PageHeadingSection";
import MetricCard from "../../../../common/Card/MetricCard";

// Dummy data mirroring the screenshot
const DUMMY_VEHICLES = [
    {
        id: "MH01AB1234",
        employeeName: "Rahul Sharma",
        employeeId: "EMP001",
        vehicleType: "Car",
        makeModel: "Hyundai Creta",
        assignedSlot: "B1-001",
        anpr: true,
        lastEntry: "Today 09:12",
        status: "Whitelisted",
    },
    {
        id: "MH02CD5678",
        employeeName: "Priya Patel",
        employeeId: "EMP002",
        vehicleType: "Car",
        makeModel: "Honda City",
        assignedSlot: "B1-002",
        anpr: true,
        lastEntry: "Today 08:55",
        status: "Whitelisted",
    },
    {
        id: "MH03EF9876",
        employeeName: "Amit Mehta",
        employeeId: "EMP003",
        vehicleType: "Bike",
        makeModel: "Royal Enfield",
        assignedSlot: "B2-025",
        anpr: true,
        lastEntry: "Today 08:55",
        status: "Whitelisted",
    },
    {
        id: "MH04GH4567",
        employeeName: "Neha Shah",
        employeeId: "EMP002",
        vehicleType: "Car",
        makeModel: "Kia Seltos",
        assignedSlot: "B1-010",
        anpr: true,
        lastEntry: "Yesterday",
        status: "Suspended",
    },
];

const TABLE_HEADERS = [
    { key: "id", label: "VEHICLE NO." },
    { key: "employeeName", label: "EMPLOYEE NAME" },
    { key: "employeeId", label: "EMPLOYEE ID" },
    { key: "vehicleType", label: "VEHICLE TYPE" },
    { key: "makeModel", label: "MAKE & MODEL" },
    { key: "assignedSlot", label: "ASSIGNED SLOT" },
    { key: "anpr", label: "ANPR" },
    { key: "lastEntry", label: "LAST ENTRY" },
    { key: "status", label: "STATUS" },
    { key: "custom_actions", label: "ACTIONS" },
];

const TenantFleetList = () => {
    const navigate = useNavigate();
    const { tenantId } = useParams();

    const [searchQuery, setSearchQuery] = useState("");
    const [vehicleType, setVehicleType] = useState("");
    const [parkingStatus, setParkingStatus] = useState("");

    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 128,
        totalPages: 13
    });

    const handlePageChange = (page) => {
        setPagination(prev => ({ ...prev, pageNumber: page }));
    };

    const handleLimitChange = (e) => {
        setPagination(prev => ({ ...prev, pageSize: parseInt(e.target.value), pageNumber: 1 }));
    };

    const breadcrumbs = [
        { label: "Parking Management", link: "/zentres/parking-management/operations" },
        { label: "Vehicle Registry", link: "/zentres/parking-management/vehicle-registry" },
        { label: "Centrum IT Services Fleet" }
    ];

    const metrics = [
        { title: "Contracted Quota", value: "30 Slots", icon: faClipboardList },
        { title: "Registered Fleet", value: "6 Vehicles", icon: faCar },
        { title: "Fixed VIP Slots", value: "12 Reserved", icon: faIdCard },
        { title: "Floating Pool Usage", value: "22 Active", icon: faChartPie },
    ];

    const handleSearch = (query) => {
        setSearchQuery(query);
    };

    const renderCell = (key, row) => {
        if (key === "employeeId") {
            return <span className="text-xs text-blue-500 font-semibold">{row[key]}</span>;
        }
        if (key === "anpr") {
            return row[key] ? (
                <FontAwesomeIcon icon={faCheckCircle} className="text-green-500 text-lg" />
            ) : (
                <span className="text-gray-400">—</span>
            );
        }
        if (key === "status") {
            const isSuspended = row[key] === "Suspended";
            return (
                <span className={`px-3 py-1 font-semibold text-[11px] rounded-full ${isSuspended
                    ? "bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400"
                    : "bg-green-50 text-green-600 dark:bg-green-500/10 dark:text-green-400"
                    }`}>
                    {row[key]}
                </span>
            );
        }
        if (key === "custom_actions") {
            const isSuspended = row.status === "Suspended";
            return (
                <button className={`px-4 py-1.5 text-[11px] font-bold rounded-lg transition-colors ${isSuspended
                    ? "bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 dark:bg-actionitembg dark:border-bordercolor dark:text-textprimary"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-dashboardbg dark:text-textsecondary"
                    }`}>
                    {isSuspended ? "Whitelist" : "Suspend"}
                </button>
            );
        }
        return <span className="text-xs font-semibold text-gray-800 dark:text-textprimary tracking-tight">{row[key]}</span>;
    };

    const headerAction = (
        <div className="flex items-center gap-3">
            <div className="w-[200px]">
                <SearchBar
                    onSearch={handleSearch}
                    placeholder="Search Vehicle"
                />
            </div>
            <div className="w-[150px]">
                <CustomSelect
                    options={[
                        { label: "Vehicle Type", value: "" },
                        { label: "Car", value: "Car" },
                        { label: "Bike", value: "Bike" },
                    ]}
                    value={vehicleType}
                    onChange={setVehicleType}
                    placeholder="Vehicle Type"
                />
            </div>
            <div className="w-[150px]">
                <CustomSelect
                    options={[
                        { label: "Parking Status", value: "" },
                        { label: "Whitelisted", value: "Whitelisted" },
                        { label: "Suspended", value: "Suspended" },
                    ]}
                    value={parkingStatus}
                    onChange={setParkingStatus}
                    placeholder="Parking Status"
                />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-gray-100 dark:bg-actionitembg text-gray-700 dark:text-textprimary rounded-lg text-sm font-semibold hover:bg-gray-200 dark:hover:opacity-85 transition-colors">
                <FontAwesomeIcon icon={faUpload} className="text-xs" />
                Export
            </button>
        </div>
    );

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-4 pt-4">
            <BreadCrum items={breadcrumbs} />
            <PageHeadingSection
                mainHeading="Centrum IT Services — Fleet Vehicles"
                subHeading="CENTRUM | Centrum IT Park (Floor 4)"
                primaryBtnText="Add Vehicle to Unit"
                primaryBtnIcon={faPlus}
                PrimaryOnClick={() => navigate(`/zentres/parking-management/vehicle-registry/${tenantId}/add`)}
                seconadaryBtnText="Bulk Import CSV"
                seconadaryBtnIcon={faUpload}
                SecandaryOnClick={() => { }}
            />

            {/* Metric Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {metrics.map((metric, index) => (
                    <MetricCard
                        key={index}
                        title={metric.title}
                        value={metric.value}
                        icon={metric.icon}
                        className="w-full"
                    />
                ))}
            </div>

            {/* Main Table */}
            <div className="shrink-0 flex-1 flex flex-col">
                <CommonTable
                    tableHeading="Fleet Vehicles List"
                    headers={TABLE_HEADERS}
                    data={DUMMY_VEHICLES}
                    renderCell={renderCell}
                    headerAction={headerAction}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onLimitChange={handleLimitChange}
                />
            </div>
        </div>
    );
};

export default TenantFleetList;
